import { useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { ValuesMarquee } from "@/components/site/ValuesMarquee";
import { FeatureMoment } from "@/components/site/FeatureMoment";
import { Video } from "@/components/site/Video";
import { Mission } from "@/components/site/Mission";
import { President } from "@/components/site/President";
import { SuccessStory } from "@/components/site/SuccessStory";
import { Galleries } from "@/components/site/Galleries";
import { ImpactStats } from "@/components/site/ImpactStats";
import { Timeline } from "@/components/site/Timeline";
import { DonorWall } from "@/components/site/DonorWall";
import { GetInvolved } from "@/components/site/GetInvolved";
import { Newsletter } from "@/components/site/Newsletter";
import { Footer } from "@/components/site/Footer";
import { DonateModal } from "@/components/site/DonateModal";
import { useScrollTo } from "@/hooks/useScrollTo";

export default function Landing() {
  const [donateOpen, setDonateOpen] = useState(false);
  const scrollTo = useScrollTo();
  const openDonate = () => setDonateOpen(true);
  const scrollInvolve = () => scrollTo("involved");

  return (
    <div data-testid="landing-page">
      <Navbar onDonate={openDonate} />
      <Hero onDonate={openDonate} onInvolve={scrollInvolve} />
      <ValuesMarquee />
      <FeatureMoment />
      <Video />
      <Mission />
      <President />
      <SuccessStory onDonate={openDonate} />
      <ImpactStats />
      <Galleries />
      <Timeline />
      <GetInvolved onDonate={openDonate} />
      <DonorWall />
      <Newsletter />
      <Footer />
      <DonateModal open={donateOpen} onClose={() => setDonateOpen(false)} />
    </div>
  );
}
